import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TimelineScorecardTotalTime from '../components/scorecards/TimelineScorecardTotalTime.vue'
import TimelineScorecardExpenses from '../components/scorecards/TimelineScorecardExpenses.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineScorecardsAll',
  props: {
    date: { default: () => new Date() }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TimelineScorecardTotalTime),
    _createVNode(TimelineScorecardExpenses, { date: _ctx.date }, null, 8, ["date"])
  ], 64))
}
}

})